
"use client"
import clsx from "clsx";
import style from "./index.module.scss";
import PAGE_TYPE from "@/constants/pageType";
import { useTranslation } from "@/i18n/client";
import ArrowDown from "@/assets/icons/arrow-down.svg";
import React, { useState, Suspense, lazy } from "react";
import CategoryIcon from "@/assets/icons/category-icon.svg";
import(/* webpackPrefetch: true */ "./categoryDropdown");

interface Props {
  pageType: PAGE_TYPE;
  categoryData: any;
  isHeaderDisabled?: boolean
}

const CategoryDropdown = lazy(() => import("./categoryDropdown"));

const Category: React.FC<Props> = ({ pageType, categoryData, isHeaderDisabled=false }) => {

  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const headerClass = isHeaderDisabled || pageType === PAGE_TYPE.HOME ? clsx(style.category, style.home) : style.category;

  return (
    <div className={headerClass}>
      <div className={style.category_btn}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <CategoryIcon className={style.category_icon} />
        <span className={style.title}>{t("header.category")}</span>
        <ArrowDown className={style.category_arrow} />
        {isHovered && (
          <Suspense fallback={null}>
            <CategoryDropdown categoryData={categoryData} />
          </Suspense>
        )}
      </div>
    </div>
  );
};

export default Category;
